import React from "react";
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import ImageOverlayButton from "./image-overlay-button";
import GradientButton from "../gradient-button";

export default function HeroSectionMedium({ slide }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
        width: "100%",
        backgroundImage: `url(${slide.backgroundImage})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        textAlign: "center",
        color: "white",
        padding: 2,
        borderRadius: "12px",
      }}
    >
      {/* <ImageOverlayButton
        text={slide.specialEvent}
        fontSize={fontSizes.info}
        textColor={darkColors.buttonTop}
        sx={{ mt: 2 }}
        width={"50%"} // Optional: Adjust width if needed
      />

      <Typography
        fontSize={fontSizes.superHeading5}
        mt={1}
        lineHeight={1.4}
        sx={{ fontFamily: "MontserratBold", marginBottom: 2 }}
      >
        {slide.title}
      </Typography>
      <Typography
        color={darkColors.betOnRaces}
        fontSize={fontSizes.heading3}
        sx={{ marginBottom: 3 }}
      >
        {slide.description}
      </Typography>
      <GradientButton
        text={slide.buttonText}
        onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling
          slide.onButtonClick(); // Call the specific slide's onClick handler
        }}
        py={2}
        variant="contained"
      />

      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          //   right: 0,
          height: isSmallScreen ? "42%" : "55%",
          width: "auto",
        }}
      >
        <img
          src={slide.athleteImage}
          alt="Athlete"
          style={{ height: "100%" }}
        />
      </Box> */}
    </Box>
  );
}
